// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3vvIH","inner":"Form_inner__Vq2UK","range":"Form_range__163Qu","name":"Form_name__244Tu","actions":"Form_actions__3OjAO"};